<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <!-- <div class="item">
            <div class="ipt">
              币种开关：
              <el-switch v-model="coinSwitch" active-text="开" inactive-text="关">
              </el-switch>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="ipt">
              划转开关：
              <el-switch v-model="transferSwitch" active-text="开" inactive-text="关">
              </el-switch>
            </div>
          </div> -->
          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="type" placeholder="币种类型">
                <el-option
                  v-for="item in typeList"
                  :key="item.key"
                  :label="item.label"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="show('新增')"
              >新增币种</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="calc(100vh - 360px)" size="small">
        <el-table-column label="租户" prop="tenantName" />
        <el-table-column label="币种" prop="coin" />
        <el-table-column label="币种类型" prop="type" />
        <el-table-column prop="" label="币种开关">
          <template slot-scope="scope">
            <span>{{ scope.row.coinSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="划转开关">
          <template slot-scope="scope">
            <span>{{ scope.row.transferSwitch ? "开" : "关" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </Pagination>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="400px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="币种开关" prop="">
            <el-switch v-model="formData.coinSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="划转开关" prop="">
            <el-switch v-model="formData.transferSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="币种类型" prop="" required>
            <el-select
              v-model="formData.type"
              placeholder="币种类型"
              clearable
              @change="typeChange"
            >
              <el-option
                v-for="item in typeList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="币种ID" prop="" required>
            <el-select v-model="formData.coin" placeholder="币种ID" clearable>
              <el-option
                v-for="item in idArr"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="租户" prop="" required>
            <el-select v-model="formData.tenantId" placeholder="租户" clearable>
              <el-option
                v-for="item in tenantList"
                :key="item.id"
                :label="item.tenantName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <div class="title" @click="add">新增提现手续费配置</div>
          <el-form-item
            label=""
            prop=""
            v-for="(item, index) in formData.withdrawConf"
            :key="index"
          >
            <el-input
              placeholder="请输入内容"
              v-model="item.WithdrawFee"
              class="input-with-select"
            >
              <el-select
                v-model="item.chain"
                slot="prepend"
                placeholder="请选择"
                class="w120"
              >
                <el-option
                  :label="i"
                  :value="i"
                  v-for="i in choinaArr"
                  :key="i"
                ></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";
import { tenantInfo } from "@/common/publicApi";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // coinSwitch: false,
      // transferSwitch: false,
      tenantId: "",
      tenantList: [],
      idArr: [],
      typeList: [ // { label: "全部", key: "" },
        { label: "现货", key: "SPOT" },
        { label: "合约", key: "CONTRACT" },
      ],
      type: "",
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: {
        coinSwitch: false,
        transferSwitch: false,
        coin: "",
        type: "",
        tenantId: "",
        withdrawConf: [],
      },
      choinaArr: [],
    };
  },
  computed: {},
  mounted() {
    api.tenantChainist().then((res) => {
      if (res.code == 0) {
        this.choinaArr = res.data;
      }
    });
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    typeChange(coinType) {
      this.formData.coin = "";
      api.tenantCoinList({ coinType }).then((res) => {
        if (res.code == 0) {
          this.idArr = res.data;
        }
      });
    },
    handleSearch() {
      api
        .getUserList({
          tenantId: this.tenantId,
          // coinSwitch: this.coinSwitch,
          // transferSwitch: this.transferSwitch,
          type: this.type,
          ...this.pagination,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData.coinSwitch = row.coinSwitch;
        this.formData.transferSwitch = row.transferSwitch;
        this.formData.coin = row.coin;
        this.formData.type = row.type;
        this.formData.tenantId = row.tenantId;
        if (row.withdrawConf) {
          this.$set(
            this.formData,
            "withdrawConf",
            JSON.parse(row.withdrawConf)
          );
        } else {
          this.$set(this.formData, "withdrawConf", []);
        }
      }
      this.title = str;
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        coinSwitch: false,
        transferSwitch: false,
        coin: "",
        tenantId: "",
        type: "",
      };
    },
    handleSave() {
      if (this.formData.coin == "") {
        return this.$message.error("请选择币种ID");
      }
      if (this.formData.tenantId == "") {
        return this.$message.error("请选择租户");
      }
      if (this.formData.type == "") {
        return this.$message.error("请选择币种类型");
      }
      api
        .coinUpdate({
          ...this.formData,
          withdrawConf: JSON.stringify(this.formData.withdrawConf),
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(this.title + "成功");
            this.close();
            this.handleSearch();
          }
        });
    },

    add() {
      let arr = this.formData.withdrawConf;
      arr.push({ chain: "", WithdrawFee: 1 });
      this.$set(this.formData, "withdrawConf", arr);
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style lang="less" scoped>
.title {
  margin-bottom: 8px;
  color: red;
  cursor: pointer;
}
/deep/ .el-input-group {
  width: 85%;
}
/deep/ .el-select--medium.w120 {
  width: 120px;
}
</style>
